import heic2any from 'heic2any';

const reduceImageSize = (image: HTMLImageElement) => new Promise<Blob | null>((resolve) => {
    const conditionalQuality = .8;
    const ratio = image.width / image.height;
    const canvas = document.createElement('canvas');
    const newWidth = 1200 * ratio;
    const heavyFile = ratio >= 1 ? newWidth >= image.width : 1200 >= image.height;

    canvas.width = heavyFile ? image.width * conditionalQuality : newWidth;
    canvas.height = heavyFile ? image.height * conditionalQuality : 1200;

    const ctx = canvas.getContext('2d');

    ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);

    canvas.toBlob(resolve, 'image/jpeg', conditionalQuality);
});

const convertImage = (file: File) => new Promise<File>(async (resolve) => {
    if (file.type !== 'image/heic') return resolve(file);

    try {
        const convertedBlob = await heic2any({
            blob: file,
            toType: 'image/jpeg',
        });
    
        if (convertedBlob) resolve(new File([convertedBlob as Blob], file.name, { type: 'image/jpeg' }));
        else resolve(file);
    } catch {
        resolve(file);
    }
});

export const optimizeImage = async (file: File) => new Promise<File | null>(async (resolve) => {
    console.log(file.size / 1024, 'kb original');

    setTimeout(() => resolve(null), 20000);

    const convertedFile = await convertImage(file);

    console.log(file, convertedFile, file === convertedFile, 'asdfasdf');

    const image = new Image();

    const imageURL = URL.createObjectURL(convertedFile);

    image.src = imageURL;

    image.onload = async () => {
        const moreThanHalfKB = file.size / 1024 > 512;
        const bigDimension = image.width > 1600 || image.height > 1200;

        if (!bigDimension || !moreThanHalfKB) resolve(file);

        const blob = await reduceImageSize(image);

        if (!blob) {
            resolve(null);
            URL.revokeObjectURL(imageURL);
        }

        const reducedFile = new File([blob!], file.name, { type: 'image/jpeg' });

        console.log(reducedFile.size / 1024, 'kb reduced');

        resolve(reducedFile);
        URL.revokeObjectURL(imageURL);
    }
});

export const checkIsImageBroken = (file: File) => new Promise((resolve) => {
    const url = URL.createObjectURL(file);

    const image = new Image(0, 0);

    image.src = url;

    image.onload = () => {
        resolve(false);
        URL.revokeObjectURL(url);
    }

    image.onerror = (e) => {
        console.error('Error loading image', e);
        resolve(true);
        URL.revokeObjectURL(url)
    }
});